import moment from "moment";

export function getTimeSlots(startTime, endTime, interval) {
    const timeSlots = [];
    const start = moment(startTime, 'HH:mm');
    const end = moment(endTime, 'HH:mm');

    while (start <= end) {
        const slot = start.format('HH:mm');
        timeSlots.push(slot);
        start.add(interval, 'minutes');
    }

    return timeSlots;
}
